export type StatusBadgeType =
  | 'warning'
  | 'success'
  | 'error'
  | 'gray'
  | 'active'
  | 'default'
  | 'amber'
  | 'cyan'
  | 'sky'
  | 'purple'
  | 'teal'
  | 'indigo';

export enum StatusBadgeCode {
  Warning = 1,
  Success = 2,
  Error = 3,
  Closed = 4,
  Active = 5,
  Amber = 6,
  Cyan = 7,
  Sky = 8,
  Purple = 9,
  Teal = 10,
  Indigo = 11,
}

export const STATUS_BADGE_CODE_MAP: Record<number, StatusBadgeType> = {
  [StatusBadgeCode.Warning]: 'warning',
  [StatusBadgeCode.Success]: 'success',
  [StatusBadgeCode.Error]: 'error',
  [StatusBadgeCode.Closed]: 'gray',
  [StatusBadgeCode.Active]: 'active',
  [StatusBadgeCode.Amber]: 'amber',
  [StatusBadgeCode.Cyan]: 'cyan',
  [StatusBadgeCode.Sky]: 'sky',
  [StatusBadgeCode.Purple]: 'purple',
  [StatusBadgeCode.Teal]: 'teal',
  [StatusBadgeCode.Indigo]: 'indigo',
};

export function resolveStatusBadgeType(
  type: StatusBadgeType | number,
): StatusBadgeType {
  if (typeof type === 'number') {
    return STATUS_BADGE_CODE_MAP[type] ?? 'default';
  }
  return type;
}
